var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"club-content"},_vm._l((_setup.state.infantClubs),function(club,club_i){return _c('div',{key:club_i},[_c('span',{staticClass:"body text-grey-900"},[_vm._v(_vm._s(club.clubName))]),_c('span',{staticClass:"caption text-grey-700 ms-2",domProps:{"innerHTML":_vm._s(club.minAndMaxAge)}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }